import React from "react";

/**
 * Glassmorphism surface. Set `hover` for the lift-on-hover interaction.
 */
const GlassCard = ({ hover = true, className = "", children, ...rest }) => (
  <div
    className={`glass-panel ${hover ? "glass-panel-hover" : ""} rounded-2xl ${className}`}
    {...rest}
  >
    {children}
  </div>
);

export default GlassCard;
